import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationItem, NetworkConstants, Person } from 'diwimamodelweb/lib';
import { GameRecordForm } from '../model/form';
import { PickerMode } from '../utilization-option-form/utilization-option-form.component';

const validatorPersonSelect: ValidatorFn =
    (control: AbstractControl): ValidationErrors|null => {
      const option = control.get('option').value
      const personValue = control.get('person').value
      return option?.personPickerMode == PickerMode.MANDATORY && personValue == undefined ? {personRequired: true} : null
    }

@Component({
  selector: 'app-gamerecord-form-utilization',
  templateUrl: './gamerecord-form-utilization.component.html',
  styleUrls: ['./gamerecord-form-utilization.component.css', '../../app.component.scss']
})
export class GamerecordFormUtilizationComponent implements OnInit {

  @Input() data: GameRecordForm
  // @Input() settingUtilizationOption: ConfigurationItem
  // @Input() person: Person[]
  @Input() formBuilder: FormBuilder
  @Input() translateService: TranslateService
  @Output() submit = new EventEmitter<void>()

  utilizationForm: FormGroup
  showPersonSelect = false
  utilizationOptions: ConfigurationItem[]

  constructor() { }

  ngOnInit(): void {
    this.utilizationOptions = this.data.constextSettings.get(NetworkConstants.SETTING_UTILIZATION_OPTION)?.values
    this.utilizationForm = this.formBuilder.group({
      option: [],
      person: []
    }, {validators: [validatorPersonSelect]})
    if (this.data.data?.plannedUtilization) this.initializeWithData()
    this.utilizationForm.valueChanges.subscribe((value) => {
      const {option, person} = this.utilizationForm.getRawValue()
      switch(option.personPickerMode) {
        case(PickerMode.PREDEFINED):{
          this.showPersonSelect = true
          const p = this.data.person?.find(el => el.identifier == option.personId)
          if (p) {
            this.utilizationForm.controls.person.setValue(p, {emitEvent: false})
            // this.data.data.plannedUtilizationDetails = {
            //   personId: p.identifier,
            //   personName: p.anzeigeName
            // }
          }
          this.utilizationForm.controls.person.disable({emitEvent: false})
          break
        }
        case(PickerMode.OPTIONAL): {
          this.showPersonSelect = true
          this.utilizationForm.controls.person.enable({emitEvent: false})
          break
        }
        case(undefined): {
          this.showPersonSelect = false
          if (person) this.utilizationForm.controls.person.setValue(undefined, {emitEvent: false})
          // delete this.data.data.plannedUtilizationDetails
          break
        }
        case (PickerMode.MANDATORY): {
          this.showPersonSelect = true
          this.utilizationForm.controls.person.enable({emitEvent: false})
          break
        }
      }
    })
  }

  initializeWithData() {
    // determine selected option
    const {plannedUtilization, plannedUtilizationDetails} = this.data.data
    const set = this.utilizationOptions?.find(el => el.identifier == plannedUtilization)
    if (set.personPickerMode == PickerMode.PREDEFINED) this.utilizationForm.controls.person.disable({emitEvent: false})
    this.utilizationForm.controls.option.setValue(set, {emitEvent: false})
    // determine selected person
    if (plannedUtilizationDetails?.personId) {
      const person = this.data.person?.find(el => el.identifier == plannedUtilizationDetails.personId)
      this.utilizationForm.controls.person.setValue(person, {emitEvent: false})
      this.showPersonSelect = true
    }
    // set values

  }

  onSubmit() {
    // set data after submit is pressed... 
    const value = this.utilizationForm.getRawValue()
    const {option, person} = value
    this.data.data.plannedUtilization = option.identifier
    this.data.data.plannedUtilizationDisplay = option.title
    if (person) {
      this.data.data.plannedUtilizationDetails = {
        personId: person.identifier,
        personName: person.anzeigeName
      }
    }
    if (option.personPickerMode == undefined) {
      this.data.data.plannedUtilizationDetails = undefined
    }
    this.submit.emit()
  }

}
